import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

import ConsolMap from "./ConsolMap";
import ConsolGeocoder from "./ConsolGeocoder.js";

$( document ).ready(function() {
	
	/**
	 * Entry point for all the maps, this works by checking for the existance of an specific container
	 * for the map to render into, and if it finds that, it kicks off rendering that map
	 * 
	 * There are three types of maps
	 * 
	 * Boots on the ground - Specific for boots on the ground
	 * Geocode address map - Any map where we will be reading in the address fields, running a geocode search for the point and then rendering
	 * Supplier Selection map - Specific for supplier selection
	 */
	
	var mapOptions = window.map_options;
	
	const bootsOnTheGroundMap = $('#bootsOnTheGroundMap');
	if(bootsOnTheGroundMap.length > 0) {
		renderBootsOnTheGroundMap(bootsOnTheGroundMap[0], mapOptions);
	}

	const geocodeAddressMap = $('#geocodeAddressMap');
	if(geocodeAddressMap.length > 0){
		
		// intially dont show, only show when we have a valid address to put a marker on
		$('.map-wrapper').hide();
		
		// Whenever a address field changes, then check to see if we need to render a map
		$('.mapAddressFields').on( "input", debounce(function(){
			
			// We blank out the geocoding fields when a change has been made, 
			// so that if the user doesn't select an address from the geocoder,
			// it saves as blank in the address table
			geocoder.fillHiddenFieldsWithGeocodeAddress({
				address: {},
				streetInfo: {}
			}, '');
			
			renderGeocodeMap(geocodeAddressMap[0], mapOptions, {
				showOptions: true
			});
		}));
	
		// We could have valid fields already populated, like validation or update
		var addressObj = {
			gpsLatitude: $('#hiddenFieldGpsLatitude').val(),
			gpsLongitude: $('#hiddenFieldGpsLongitude').val()
		};
		
		// so call render geocode map and use coords
		const geocoder = new ConsolGeocoder(mapOptions);
		if(geocoder.validateLatLngOfAddressModel(addressObj)){
			
			renderGeocodeMap(geocodeAddressMap[0], mapOptions, {
				useCoords: true
			});
		}
	}
	
	const supplierSelectionMap = $("#supplierSelectionMap");
	if(supplierSelectionMap.length > 0){
		renderSupplierSelectedMap(supplierSelectionMap[0], mapOptions);
	}
});


function renderBootsOnTheGroundMap(bootsOnTheGroundMap, mapOptions){
	
	
    // Boots on the ground gets its data from the tag attribute and it is in json
	var jsonData = $(bootsOnTheGroundMap).attr('jsonData');
	if(!jsonData) return;
		
	var data = JSON.parse(jsonData);		
	var infoMessage = $(bootsOnTheGroundMap).attr('infoMessage');
	
	// validate the gps coords of the data
	const geocoder = new ConsolGeocoder(mapOptions);
	
	var dataArr = [];
	for(var i=0; i<data.length; i++) {
		
		var item = data[i];
		
		if(geocoder.validateLatLngOfAddressModel({
			gpsLatitude: item.lat,
			gpsLongitude: item.lng
		})){
			dataArr.push(item);
		}
	}
	
	var root = createRoot(bootsOnTheGroundMap);
	root.render(<ConsolMap 
		data={dataArr} 
		infoMessage={infoMessage}
		mapType={'boots'}
		options={mapOptions} />);
}

function renderSupplierSelectedMap(supplierSelectionMap, mapOptions){
	
	var jsonData = supplierSelectionMap.getAttribute('jsonData');
	if(!jsonData) {
		$('#supplierSelectionMapTitle').hide();
		$('#supplierSelectionMap').hide();	
		return;
	}
	
	var data = JSON.parse(jsonData);
	
	var dataArray = [];
	dataArray.push(data);
	
	var root = createRoot(supplierSelectionMap);
	root.render(<ConsolMap 
		data={dataArray} 
		infoMessage={supplierSelectionMap.getAttribute('infoMessage')}
		mapType={'supplierSelection'}
		options={mapOptions} />);
}

function renderGeocodeMap(newOrderMap, mapOptions, renderOptions){
	
	const geocoder = new ConsolGeocoder(mapOptions);
	const minGeocodeRelevanceForAutoCorrection = mapOptions.defaults.minGeocodeRelevanceForAutoCorrection
	
	var addressObj = {
		streetAddress: $('.mapStreetAddressInput').val(),
		suburb: $('.mapSuburbInput').val(),
		state: $('.mapStateInput').val(),
		postcode: $('.mapPostcodeInput').val(),
		streetNumber: $('.mapStreetNumberInput').val(),
		streetName: $('.mapStreetNameInput').val(),
		streetType: $('.mapStreetTypeInput').val()
	};
	
	// Check the address to see if it is complete
	if(!geocoder.validateAddress(addressObj)) {
		$('.map-wrapper').hide();
		return;
	}
	
	var renderMapFn = function(data){
		
		// if multiple addresses then show those on screen and dont render
		if(data && data.length > 0) {
			
			$('.map-wrapper').show();
		
			var orderId = $('#hiddenFieldMapOrderId').val();
			var hirePeriod = $('#hiddenFieldMapHidePeriod').val();
			
			// if more than one option found or our tolerance for relevance is lower than our minimum then
			// show the selection list
			if(renderOptions.showOptions && (data.length > 1 || data[0].relevance < minGeocodeRelevanceForAutoCorrection)) {
				
				$('.address-candidates').show();
				$('.addressCandidatesList').empty().show();
				
				for(let i=0; i<data.length; i++) {
				
					var $div = $('<div><span class="address" style="margin-right: 15px;">' + data[i].addressString + '</span><button type="button">Select</button></div>');
					
					
					$div.on("click", function(){

						$('.address-candidates').hide();
						
						// create a data array of 1 value
						var dataArr = [];
						
						var item = data[i];
						item.orderId = orderId;
						item.hirePeriod = hirePeriod;
						
						dataArr.push(item);
						
						geocoder.fillInputFieldsWithGeocodeAddress(data[i], 'ACCEPTED');
						
						const root = createRoot(newOrderMap);
						root.render(<ConsolMap 
							data={dataArr} 
							infoMessage={''}
							mapType={'order'}
							options={mapOptions} />);
					});
					
					$('.addressCandidatesList').append($div);
				}
				
			} else {
				
				$('.address-candidates').hide();
				$('.addressCandidatesList').hide();
				
				var item = data[0];
				item.orderId = orderId;
				item.hirePeriod = hirePeriod;
				
				geocoder.fillHiddenFieldsWithGeocodeAddress(item, 'APPLIED');
				
				// show the first result in the array
				const root = createRoot(newOrderMap);
				root.render(<ConsolMap 
					data={data} 
					infoMessage={''}
					mapType={'order'}
					options={mapOptions} />);
			}
		}
		
	}
	
	var errorFn = function(errorResult){
		
		if(errorResult.error) {
			$('.geocodeErrorDetails').show().text(error);
		} else if(errorResult.errorReason == 'notfound') {
			$('.geocodeErrorDetails').show().text(mapOptions.messages['address.geocode.error.not.found']);
		}
		
		// Add additional errors here as needed
		
		resetMap();
	}

	if(renderOptions.useCoords) {
		
		renderMapFn([{
			lat: $('#hiddenFieldGpsLatitude').val(),
			lng: $('#hiddenFieldGpsLongitude').val(),
			address: {
				district: $('#hiddenFieldSuburb').val(),
				postalCode: $('#hiddenFieldPostcode').val(),
				stateCode: $('#hiddenFieldState').val(),
				label: $('#hiddenFieldMappedFullAddress').val(),
				houseNumber: $('#hiddenFieldStreetNumber').val()
			},
			streetInfo: {
				baseName: $('#hiddenFieldStreetName').val(),
				streetType: $('#hiddenFieldStreetType').val()
			},
			markerType: "base",
			relevance: $("#hiddenFieldRelevance").val(),
		}]);
		
	} else {
		
		const fullAddress = geocoder.toFullAddressString(addressObj);
		
		console.log("Geocoding address: " + fullAddress);
		geocoder.geocodeAddress(mapOptions.geocoder, fullAddress, renderMapFn, errorFn);
	}	
}

function debounce(func, timeout = 600){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * Global functions that can be called from the page to trigger behaviour
 */

// Removes the map entirely
window.resetMap = function() {
	$('.addressCandidatesList').empty().hide();
	$('.map-wrapper').empty().hide();
}
